import { configureStore } from "@reduxjs/toolkit";
import companyReducer from "./companySlice";
const store = configureStore({
  reducer: {
    Company: companyReducer,
  },
});
export default store;
